import axios from "axios";
import { Base_URL } from "../url";

export const saveAddressDetails = async (addressData, username) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Address/SaveAddress?UserName=${username}`,
      addressData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving address details!";
  }
};

export const getAllResources = async () => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/ResourceMasters`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

export const getAllCountries = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CountryMaster/GetAllCountries`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching countries!";
  }
};

export const getRegionsByCountry = async (countryCode) => {
  try {
    const response = await axios.post(`${Base_URL}/RegionMaster/GetRegionsByCountry`, {
      countryCode: countryCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching regions!";
  }
};

export const getDistrictsByRegion = async (regionCode) => {
  try {
    const response = await axios.post(`${Base_URL}/DistrictMaster/GetDistrictsByRegion`, {
      regionCode: regionCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching districts!";
  }
};

export const getTehsilsByDistrict = async (districtCode) => {
  try {
    const response = await axios.post(`${Base_URL}/TehsilMaster/GetTehsilsByDistrict`, {
      districtCode: districtCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching tehsils!";
  }
};

export const getCitiesByTehsil = async (tehsilCode) => {
  try {
    const response = await axios.post(`${Base_URL}/CityMaster/GetCitiesByTehsil`, {
      tehsilCode: tehsilCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching cities!";
  }
};